module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAGCAYAAADKfB7nAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAALdJREFUeNpiZAACRUVFByCVD8QCQLzw/v37CxhwAKDaBCAVD8QfgHgiE1AgAMjY/+vXr4Bv3745/Pv3bz5QrACH5n4gNR+qGQT2gwTP8/Hx/QdywJiJiem/pKTkeSyaBYD4PxAbIIkZgIj3MM0wLCgo+B+LAQpAvB9dnAmINwBtRRFkZ2d/gK4QGC4PkJwOdxULkG6UkJAI+PTpkwDIIH5+fgYWFpaFOMJwIVDTehANxPZAnAAQYADCrTcg0JbOHwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-three/exercise-3/cinetics-line/dots-1.png
// module id = 263
// module chunks = 0